import { createSlice } from "@reduxjs/toolkit";
import { toGetLoyaltyProgramDetails } from "../actions/loyaltyProgramDetails.actions";

const initialState = {
  loyaltyProgramDetails: {
    list: [],
    status: "",
  } as any,
  loading: false,
  error: null as unknown | null,
};
export const loyaltyProgramDetailsSlice = createSlice({
  name: "program",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(toGetLoyaltyProgramDetails.pending, (state) => {
      state.loyaltyProgramDetails = { list: [], status: "idle" };
    });
    builder.addCase(toGetLoyaltyProgramDetails.fulfilled, (state, action) => {
      state.loyaltyProgramDetails = {
        list: action.payload.data,
        status: "succedded",
      };
    });
    builder.addCase(toGetLoyaltyProgramDetails.rejected, (state, action) => {
      state.loyaltyProgramDetails = { list: [], status: "rejected" };
      state.error = action.payload;
    });
  },
});

export default loyaltyProgramDetailsSlice.reducer;
